import './style.sass';

import parser from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonSmallTitle from '../../../common-components/common-small-title';

const media = [
    {
        title: 'Фонд развития территорий усовершенствовал онлайн-сервис для&nbsp;дольщиков',
        subtitle: 'Риа новости',
        icon: '/images/pic/fondrt/news/ria-novosti.svg',
        link: 'https://ria.ru/20230214/onlayn-servis-1851875010.html',
    },
    {
        title: 'Обманутые дольщики смогут оформлять выплату компенсаций через Госуслуги',
        subtitle: 'РБК',
        icon: '/images/svg/fondrt/rbkLogo.svg',
        link: 'https://realty.rbc.ru/news/648b12629a794718b601c2da',
    },
];

function AboutUs() {
    return (
        <FullWrapper className="fontrt-about-us">
            <div className="fontrt-about-us__inner">
                <CommonSmallTitle>СМИ о проекте:</CommonSmallTitle>
                {media.map(data => (
                    <a
                        key={data}
                        href={data.link}
                        target="_blank"
                        className="fontrt-about-us__wrapper"
                        rel="noopener noreferrer nofollow"
                    >
                        <img className="fontrt-about-us__icon" src={data.icon} alt="icon" />
                        <div className="fontrt-about-us__info">
                            <div className="fontrt-about-us__info-title">{parser(data.title)}</div>
                            <div className="fontrt-about-us__info-subtitle">{data.subtitle}</div>
                        </div>
                    </a>
                ))}
            </div>
        </FullWrapper>
    );
}

export default AboutUs;
